import * as React from 'react'
import { Card } from 'components'
import { useTranslation } from 'i18n'
import PaginationView from 'components/layouts/PaginationView'
import { GET_POSTS } from 'request/apollo/queries/post'

export const getPostsVariables = (artistId: string) => ({
  artistId,
  pageInput: { limit: 5 },
})

const View = function ({ id: artistId, isArtistPage = false }) {
  const { t } = useTranslation('components')

  return (
    <div>
      <PaginationView
        query={GET_POSTS}
        EmptyView={
          <p style={{ textAlign: 'center' }}>{t('PostView.noPost')}</p>
        }
        names={['artist', 'posts']}
        variables={getPostsVariables(artistId)}
        infiniteScroll
        renderItem={item => (
          <Card.Post
            key={item.id}
            post={item}
            isArtistPage={isArtistPage}
            style={{ marginBottom: 20 }}
          />
        )}
      />
    </div>
  )
}

export default View
